import { Fragment, useEffect, useRef, useState } from "react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import ServiceLocator from "../../../../../domain/service-locator";
import { MonotoneAudioPlayerContainer } from "../../containers/monotone-audio-player-container";
import { MonotoneAreaContainer } from "../../containers/monotone-area-container";
import { MonotoneMinAudioPlayerHeight } from "../../const/audio-player-layout";
import { useSearchParams } from "react-router-dom";

export const MonotoneGuidesPage = () => {
  const localizedEntityRepository = ServiceLocator.LocalizedEntityRepository;
  const { areas, tours, guides } = localizedEntityRepository.entities.watch();
  const areaRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [hasScrolled, setHasScrolled] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (hasScrolled) return;

    // areasがまだ読み込まれていない場合は待機
    if (!areas || areas.length === 0) return;

    // URLからクエリパラメータを取得
    const areaId = searchParams.get("areaId");

    if (!areaId) return;

    // 最初のエリアの場合はスクロールしない
    if (areaId === areas[0].id) {
      setHasScrolled(true);
      return;
    }

    // DOM要素が確実に存在するまで少し待つ
    const timeoutId = setTimeout(() => {
      if (areaId && areaRefs.current[areaId]) {
        areaRefs.current[areaId]?.scrollIntoView({
          behavior: "auto",
          block: "start",
        });
        setHasScrolled(true);
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [hasScrolled, areas, searchParams]);

  return (
    <AnimatedPageTransition>
      <div className="fixed inset-0">
        <div
          className={
            "flex flex-col px-6 pt-0 gap-0 overflow-y-auto hidden-scrollbar h-full"
          }
          style={{
            paddingBottom: `${MonotoneMinAudioPlayerHeight + 20}px`,
          }}
        >
          {areas
            .filter((x) => !x.isDefault)
            .map((area) => {
              const areaTours = tours.filter((tour) => tour.areaId === area.id);
              const areaGuides = guides.filter((guide) =>
                areaTours.some((tour) => tour.id === guide.tourId)
              );
              return (
                <Fragment key={area.id}>
                  <div ref={(el) => (areaRefs.current[area.id] = el)} />
                  <div key={area.id} id={area.id}>
                    <MonotoneAreaContainer
                      area={area}
                      tours={areaTours}
                      guides={areaGuides}
                    />
                  </div>
                </Fragment>
              );
            })}
        </div>
        <MonotoneAudioPlayerContainer />
      </div>
    </AnimatedPageTransition>
  );
};
